import InfiniteScroll from "react-infinite-scroll-component"
import { useNavigate, useSearchParams } from "react-router-dom"

import Skeleton from "@/ui/components/Skeleton"
import EmptyRow from "@/ui/components/EmptyRow"
import Table from "@/ui/components/Table"
import { ModalPopUp } from "@/components/common/element/ModalPopUp"
import { Header } from "@/components/common/header/Header"
import { useStore } from "@/stores/RootStoreContext"
import { MenuAdmin } from "@/components/admin/MenuAdmin"

import * as TrinityAPI from "@/requests/TrinityAPI"

import { MenuManager } from "../MenuManager"
import { CurrecyExchangeUserItem } from "./Item"

import { useEffect, useState, type FC } from "react"
import type { IPageResponse } from "@/types/IPageResponse"
import type { IUser } from "@/types/user/IUser"
import type { IModalMessage } from "@/types/error/IModalMessage"
import type { IErrorModel } from "@/types/error/IErrorModel"

import style from "./style.module.scss"
import { CurrencyExchangeForm } from "./Form"
import { CurrencyExchangeHistory } from "./History"

const tableColumns: string[] = ["Имя", "Email", "USD", "EUR", "CNY", "AED", "Действия"]

export const CurrencyExchange: FC = () => {
  const { userStore } = useStore()

  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [errors, setErrors] = useState<IErrorModel>()
  const [searchQuery, setSearchQuery] = useState("")
  const [userList, setUserList] = useState<IPageResponse<IUser>>()
  const [page, setPage] = useState(0)
  const [isLoading, setLoading] = useState(true)
  const [formUser, setFormUser] = useState<IUser | null>(null)
  const [extendedUserId, setExtendedUserId] = useState<number | null>(null)
  const [historyUser, setHistoryUser] = useState<IUser | null>(null)

  const handleCloseForm = () => {
    setFormUser(null)
  }

  const handleOpenForm = (user: IUser) => {
    setFormUser(user)
  }

  const handleCloseHistoryForm = () => {
    setHistoryUser(null)
  }

  const handleOpenHistoryForm = (user: IUser) => {
    setHistoryUser(user)
  }

  const fetchUsers = (isRefetch = false) => {
    TrinityAPI.getUserList(
      "ROLE_CLIENT&withBalances=true",
      isRefetch ? 0 : page,
      searchQuery,
      response => {
        if (response.status === 200) {
          const currentItems = page === 0 ? new Array<IUser>() : userList?.items || new Array<IUser>()
          !isRefetch && setPage(page + 1)
          isRefetch && setExtendedUserId(null)
          if (isRefetch) {
            setUserList({
              items: response.data.items,
              totalPages: response.data.totalPages
            })
          } else {
            setUserList({
              ...userList,
              items: currentItems.concat(response.data.items),
              totalPages: response.data.totalPages
            })
          }
        } else {
          setModalMessage({ title: "Ошибка!", text: "Ошибка загрузки реестра: " + response.data.message })
        }
      },
      () => setLoading(false)
    )
  }

  useEffect(() => {
    fetchUsers()
  }, [])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} error={errors} />
      {formUser && <CurrencyExchangeForm refetch={() => fetchUsers(true)} user={formUser} onClose={handleCloseForm} />}
      {historyUser && (
        <CurrencyExchangeHistory user={historyUser} refetch={() => fetchUsers(true)} onClose={handleCloseHistoryForm} />
      )}
      {userStore.isManager ? <MenuManager active="currencyExchange" /> : <MenuAdmin active="currencyExchange" />}
      <main className="main-container" id="scrollable">
        <Header />
        <div className="container">
          <div className={style.mainContainer}>
            <h1 className="ui-heading">Обмен валют</h1>
            <Table.Wrapper title="Пользователи">
              {isLoading ? (
                <Skeleton rows={4} />
              ) : (
                <InfiniteScroll
                  scrollableTarget="scrollable"
                  next={fetchUsers}
                  hasMore={page < (userList?.totalPages || 0)}
                  loader={<>Загрузка...</>}
                  dataLength={userList?.items.length || 0}
                  className="message-list"
                  style={{ listStyleType: "none" }}
                >
                  <div>
                    <Table.Header className={style.usersTableRow} columns={tableColumns} />
                    {(userList?.items?.length || 0) > 0 ? (
                      userList?.items.map((u, index) => (
                        <CurrecyExchangeUserItem
                          extendedUserId={extendedUserId}
                          onViewHistory={handleOpenHistoryForm}
                          setExtendedUserId={setExtendedUserId}
                          onExchange={handleOpenForm}
                          setModalMessage={setModalMessage}
                          item={u}
                          key={index.toString()}
                        />
                      ))
                    ) : (
                      <EmptyRow text="Пользователей не найдено" />
                    )}
                  </div>
                </InfiniteScroll>
              )}
            </Table.Wrapper>
          </div>
        </div>
      </main>
    </>
  )
}
